var _path, _path2, _path3, _rect, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAccounts = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 16,
  viewBox: "0 0 18 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4.33594 11.3333L6.66927 6L9.06927 11.3333",
  stroke: "#C9C9C9",
  strokeWidth: 1.2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.86719 9.5332H8.46719",
  stroke: "#C9C9C9",
  strokeWidth: 1.2,
  strokeMiterlimit: 10
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.9313 6.66675V11.4001H11.7313C11.0646 11.4001 10.5312 10.8667 10.5312 10.2001C10.5312 9.53341 11.0646 9.00008 11.7313 9.00008H12.9313",
  stroke: "#C9C9C9",
  strokeWidth: 1.2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 1.33325,
  width: 16,
  height: 13.3333,
  rx: 2,
  stroke: "#C9C9C9",
  strokeWidth: 1.2
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M1 4L17 4.0001",
  stroke: "#C9C9C9",
  strokeWidth: 1.2
})));
export default SvgAccounts;